/**
 * CoConsoleXNav.jsx
 * ---------------------------------------------------------------------------
 * Sticky left rail on desktop (≥ 900px), horizontally-scrollable pill bar on
 * mobile. Data-driven from SUBTABS in coconsolexTokens.js.
 *
 * The active subtab gets a 3px ink-navy left border (desktop) or bottom
 * border (mobile pill). On mobile, the active pill auto-scrolls into view
 * on mount.
 */

import React, { useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { cxTokens as t, SUBTABS } from "../../lib/coconsolexTokens.js";

export default function CoConsoleXNav() {
  const { pathname } = useLocation();
  const railRef = useRef(null);

  useEffect(() => {
    if (!railRef.current) return;
    const active = railRef.current.querySelector("[data-active='true']");
    if (active && window.innerWidth < 900) {
      active.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
    }
  }, [pathname]);

  return (
    <nav
      role="navigation"
      aria-label="CoConsoleX subtabs"
      ref={railRef}
      data-cx-rail
      style={{
        background: t.paper,
        borderRight: `1px solid ${t.rule}`,
      }}
    >
      <ul
        style={{
          listStyle: "none",
          margin: 0,
          padding: "16px 0",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {SUBTABS.map((tab) => (
          <li key={tab.path}>
            <NavLink
              to={tab.path}
              end={tab.path === "/coconsolex"}
              data-active={pathname === tab.path}
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "baseline",
                gap: 14,
                padding: "14px 22px",
                textDecoration: "none",
                color: t.ink,
                borderLeft: isActive ? `3px solid ${t.ink}` : "3px solid transparent",
                background: isActive ? t.navTint : "transparent",
                fontFamily: "'Inter', sans-serif",
                fontSize: 15,
                fontWeight: isActive ? 500 : 400,
                minHeight: 44,
                lineHeight: 1.3,
              })}
            >
              <span
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontStyle: "italic",
                  fontSize: 13,
                  color: t.slate,
                  letterSpacing: "0.18em",
                  minWidth: 32,
                }}
              >
                {tab.roman}
              </span>
              <span>{tab.title}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
